"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activities.panel.all': 'Todas las actividades',
    'activities.panel.telegram': 'Telegram',
    'activities.panel.whatsapp': 'WhatsApp',
    'activities.panel.noLogs': 'No hay actividades para mostrar.',
    'activities.panel.noData': 'No hay datos de canales disponibles.',
    'activities.panel.groups': 'Grupos',
    'activities.panel.channels': 'Canales/Grupos',
    'activities.panel.inboxes': 'Buzónes',
    'activities.panel.trackingEnabled': 'Seguimiento activo',
    'activities.panel.connectionActive': 'Conexión activa',
    'activities.panel.critical': 'Crítico',
    'activities.panel.criticalDetected': 'Crítico detectado',
    'activities.panel.noAlerts': 'Sin alertas',
    'activities.panel.requiresAction': 'Requiere acción',
    'activities.panel.spamQueue': 'Spam/Cola',
    'activities.panel.warning': 'Advertencia',
    'activities.panel.noWarnings': 'Sin advertencias',
    'activities.panel.status': 'Estado',
    'activities.panel.status.good': 'Bueno',
    'activities.panel.status.warning': 'Advertencia',
    'activities.panel.status.danger': 'Peligro',
    'activities.panel.lastSync': 'Última sincronización',
    'activities.panel.neverSynced': 'Nunca',
    'activities.panel.justNow': 'Ahora mismo',
    'activities.panel.minutesAgo': 'min atrás',
    'activities.panel.hoursAgo': 'h atrás',
    'activities.panel.daysAgo': 'd atrás',
};
